export default "__VITE_ASSET__BZLEW2Nj__"